import { Input } from 'antd'
import type React from 'react'
import { useState } from 'react'

interface HourMinuteInputProps {
  value?: string
  onChange?: (value: string) => void
}

export const formatMinutesToParts = (totalMinutes: number): string => {
  // Formats total minutes to days, hours, and minutes
  const days = Math.floor(totalMinutes / (60 * 24))
  const remainingMinutesAfterDays = totalMinutes % (60 * 24)
  const hours = Math.floor(remainingMinutesAfterDays / 60)
  const minutes = remainingMinutesAfterDays % 60

  const formatted = `${days > 0 ? `${days}d ` : ''}${hours > 0 ? `${hours}h ` : ''}${
    minutes > 0 ? `${minutes}m` : ''
  }`.trim()

  return formatted || '0m'
}

export const HourMinuteInput: React.FC<HourMinuteInputProps> = ({ value = '', onChange }) => {
  // Designed to work with AntD form. Accepts hours entry and reformats it to include hours and minutes

  const [inputValue, setInputValue] = useState<string>(value)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setInputValue(newValue)
    onChange?.(newValue) // Notify form of the change
  }

  const handleBlur = () => {
    const valueInHours = parseFloat(inputValue)
    if (!isNaN(valueInHours)) {
      const totalMinutes = Math.round(valueInHours * 60)
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60

      const formatted = `${hours > 0 ? `${hours}h ` : ''}${minutes > 0 ? `${minutes}m` : ''}`.trim()
      setInputValue(formatted || '0m')
      onChange?.(formatted || '0m') // Notify form of the change
    }
  }

  return (
    <Input
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder='Enter hours'
      style={{ width: '150px' }}
    />
  )
}

export default HourMinuteInput

export function parseTimeStringToMinutes(timeString: string) {
  // Parses the input value of the above component to minutes
  const hoursMatch = timeString.match(/(\d+)h/) // Matches '5h' or '55h'
  const minutesMatch = timeString.match(/(\d+)m/) // Matches '30m'

  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0
  const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0

  return hours * 60 + minutes
}
